module.exports = __webpack_public_path__ + "static/media/white-chevron-right-icon.106f848c.svg";